import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, AppText, Column, styled, Theme, Spinner } from '@streem/ui-react';
export const ExpertAvatar = ({ companyInfo, className }) => {
    const agentAvatar = companyInfo?.agentAvatar ? companyInfo.agentAvatar : '';
    const agentName = companyInfo?.agentName ? companyInfo.agentName : 'Agent';
    const companyName = companyInfo?.companyName ? companyInfo.companyName : 'Company';
    return (_jsx(PulseEffectContainer, { className: className, children: _jsxs(Column, { style: {
                zIndex: 3,
                marginBottom: '50%',
                justifyContent: 'center',
                alignItems: 'center',
            }, children: [_jsx(PulseEffectCircleLarge, {}), companyInfo ? (_jsxs(_Fragment, { children: [_jsx(PulseEffectWrapperSmall, { children: _jsx(Avatar, { src: agentAvatar, displayName: agentName, size: "medium" }) }), _jsx(AppText, { color: "white", size: "large", headingFontFamily: true, bold: true, children: agentName }), _jsx(AppText, { color: "white", headingFontFamily: true, children: companyName })] })) : (_jsx(Spinner, { size: "small" }))] }) }));
};
const PulseEffectCircleLarge = styled.span({
    width: 50,
    height: 50,
    zIndex: 2,
    borderRadius: '100%',
    position: 'absolute',
    animation: `${Theme.keyframes.growOutLarge} 1700ms ease-out infinite`,
    backgroundColor: Theme.colors.azure,
});
const PulseEffectWrapperSmall = styled.span({
    animation: `${Theme.keyframes.flexSmall} 1700ms ease-in-out infinite`,
});
const PulseEffectContainer = styled.div `
    position: absolute;
    top: 15%;
    margin: 0 auto;
    width: 100%;
    z-index: 3;
`;
//# sourceMappingURL=expert_avatar.js.map